import React, { useState, useCallback, useRef, useEffect } from "react";
import { Stack, Grid, Button, Box } from "@mui/material";
import { Print, RestoreOutlined, ViewList } from "@mui/icons-material";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import Axios from "axios";

import Sidebar from "../../sidebar/sidebar";
import { companylogo } from "../../../assets/images";
import { BaseUrl } from "../../../Environment";
import "../../PrintDocs/PrintDocs.css";

import { LoanReport } from "../../LoanReport/LoanReport";
import { getSecureItem } from "../../../utilsFunctions";

const docTypes = [{ label: "Borrower Statement", value: "6" }];

const BorrowerAccountStatement = () => {
  const loggedinUser = getSecureItem("loggedinUser");

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const [selectedDocType, setSelectedDocType] = useState({
    label: "Borrower Statement",
    value: "6",
  });
  const [branchData, setBranchData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loanData, setLoanData] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [renderedComponent, setRenderedComponent] = useState(null);
  const [pdfData, setPdfData] = useState([]);
  const [noOfLoans, setNoOfLoans] = useState(30);

  const getAllCustomers = async () => {
    const token = getSecureItem("token");
    const companyId = getSecureItem("loggedinUserCompany");
    let collectorId = loggedinUser?.userId;

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(`${BaseUrl}/customer/getAllCustomers?name=&companyId=${companyId}&branchId=${selectedBranch?.value || ''}`, {
      headers: headers,
    })
      .then((resp) => {
        if (resp.status == 200) {
          const cList = resp.data?.map((item) => ({
            label: item?.cust_id
              ? `${item.firstName} ${item.lastName} (${item.cust_id})`
              : `${item.firstName} ${item.lastName}`,
            value: item.customerId,
          }));
          setCustomerData(cList);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const fetchBranches = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const { data } = await Axios.get(`${BaseUrl}/branch/getAllBranches`, {
        params: { companyId: loggedinUser.companyId },
        headers,
      });

      const branchData = loggedinUser?.userType == "superAdmin" ? data?.data : data?.data?.filter((item) => item?.branchId == loggedinUser?.branchId);

      setBranchData(branchData?.map(item => ({
        label: item.branchName,
        value: item.branchId
      })) || []);
    } catch (err) {
      console.error("Fetch Branches Error:", err);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  useEffect(() => {
    getAllCustomers();
  }, [selectedBranch]);

  const getLoanAgreementDetails = async () => {
    const token = getSecureItem("token");

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(
      BaseUrl + `/loan/getLoanAgreementDetails?loanId=${selectedLoan?.value}`,
      {
        headers: headers,
      }
    )
      .then((resp) => {
        if (resp.status == 200) {
          setPdfData(resp.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllLoans = async () => {
    const token = getSecureItem("token");
    const companyId = getSecureItem("loggedinUserCompany");

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(
      BaseUrl +
        `/loan/getLoansforCustomers?customerId=${selectedCustomer?.value}&companyId=${companyId}`,
      {
        headers: headers,
      }
    )
      .then((resp) => {
        if (resp.status == 200) {
          const loanIds = resp.data?.map((item) => ({
            label: item.loanId,
            value: item.loanId,
          }));
          setLoanData(loanIds);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (selectedCustomer) {
      getAllLoans();
    }
  }, [selectedCustomer]);

  useEffect(() => {
    setPdfData([]);
    if (selectedDocType && selectedCustomer) {
      if (selectedDocType?.value === "6") {
        if (selectedLoan) {
          getLoanAgreementDetails();
        }
      }
    }
  }, [selectedCustomer, selectedLoan]);

  const handleDocTypeChange = useCallback((val) => {
    setSelectedDocType(val);
    setSelectedCustomer(null);
    setSelectedLoan(null);
    setRenderedComponent(null);
  }, []);

  const handleCustomerChange = useCallback((val) => {
    setSelectedCustomer(val);
    setSelectedLoan(null);
  }, []);

  const handleLoanChange = useCallback((val) => {
    setSelectedLoan(val);
  }, []);

  const handleBranchChange = useCallback((val) => {
    setSelectedBranch(val);
    setSelectedCustomer(null);
  }, []);

  const handleReset = () => {
    setSelectedDocType({ label: "Borrower Statement", value: "6" });
    setSelectedBranch(null);
    setSelectedCustomer(null);
    setSelectedLoan(null);
    setRenderedComponent(null);
  };

  const handleSubmit = () => {
    if (selectedDocType && selectedCustomer) {
      if (selectedLoan) {
        setRenderedComponent(
          <LoanReport
            data={pdfData}
            printRef={printRef}
            noOfLoans={noOfLoans}
          />
        );
      }
    }
  };

  return (
    <>
      <Sidebar />

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="paddingSidebar"
      >
        <img src={companylogo} alt="logo" />
      </Stack>

      <Stack spacing={1} className="paddingSidebar">
        <Box
          className="print-docs"
          sx={{
            width: "70%",
            paddingInline: "10px",
            paddingTop: "20px",
            backgroundColor: "#fff",
          }}
        >
          <Grid container alignItems="center">
            <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Document Type</strong>
                <Select
                  options={docTypes}
                  value={selectedDocType}
                  onChange={handleDocTypeChange}
                  placeholder="Select Document Type"
                />
              </Stack>
            </Grid>
            {selectedDocType?.value == "6" && (
              <Grid item xs={12} sx={{ padding: "0 10px" }}>
                <Stack spacing={0.5} marginBottom={2}>
                  <strong>
                    Enter the number of records to display per page(Max: 40)
                  </strong>
                  <input
                    type="number"
                    min={1}
                    max={40}
                    value={noOfLoans}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (!isNaN(value) && value >= 1 && value <= 40) {
                        setNoOfLoans(value);
                      } else if (e.target.value === "") {
                        setNoOfLoans("");
                      }
                    }}
                    style={{
                      border: "0.5px solid gray",
                      height: "15px",
                      fontSize: "15px",
                      padding: "10px",
                      borderRadius: "5px",
                    }}
                  />
                </Stack>
              </Grid>
            )}
            <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Branches</strong>
                <Select
                  options={branchData}
                  isDisabled={(loggedinUser?.company?.planId == 3) ? false : true}
                  value={selectedBranch}
                  onChange={handleBranchChange}
                  placeholder="Select Branch"
                />
              </Stack>
            </Grid>
            <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Customers</strong>
                <Select
                  options={customerData}
                  isDisabled={!selectedDocType}
                  value={selectedCustomer}
                  onChange={handleCustomerChange}
                  placeholder="Select Customer"
                />
              </Stack>
            </Grid>
            <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Loans</strong>
                <Select
                  options={loanData}
                  isDisabled={!selectedCustomer}
                  value={selectedLoan}
                  onChange={handleLoanChange}
                  placeholder="Select Loan"
                />
              </Stack>
            </Grid>
            <Grid item xs={12} sx={{ padding: "0 10px", marginBottom: "20px" }}>
              <Stack direction="row" spacing={5} alignItems="center">
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  startIcon={<RestoreOutlined />}
                  onClick={handleReset}
                >
                  Reset
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<ViewList />}
                  onClick={handleSubmit}
                  disabled={
                    selectedDocType && selectedCustomer
                      ? selectedLoan
                        ? false
                        : true
                      : true
                  }
                >
                  Show PDF
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Stack>

      {/* Render the selected component */}
      {renderedComponent && (
        <Box ref={printRef} className="paddingSidebar">
          {renderedComponent}
        </Box>
      )}

      <div
        style={{ display: "flex", justifyContent: "center", marginBlock: 10 }}
      >
        <Button
          variant="outlined"
          style={{ minWidth: 200, marginBottom: "20px" }}
          startIcon={<Print />}
          onClick={handlePrint}
          disabled={!renderedComponent}
        >
          Print
        </Button>
      </div>
    </>
  );
};

export default BorrowerAccountStatement;
